import type { UseAsyncDataResT } from '@dr.pogodin/react-global-state';

import { getAdminUsers } from 'services/user';

import { type UserT, useAsyncData } from 'utils';

export function useAdminUsers(): UseAsyncDataResT<UserT[]> {
  return useAsyncData('adminUsers', getAdminUsers);
}
